/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popGift.vue?vue&type=template&id=57e37540&scoped=true"
import script from "./popGift.vue?vue&type=script&lang=js"
export * from "./popGift.vue?vue&type=script&lang=js"
import style0 from "./popGift.vue?vue&type=style&index=0&id=57e37540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e37540",
  null
  
)

export default component.exports